export const zIndex = {
  /*
   * modal z-index should be used for all modal
   */
  modal: 6,
  controls: 5,
};

export default { zIndex };
